import { AuthEnums } from "models/enums";
import { CompanyService } from "services";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";

function useReadOnlyState(state: ApiModels.IncomingInvoiceState) {
  const isSignee = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.IncomingInvoicesSignee);
  const isIncominInvoiceAdmin = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.IncomingInvoicesAdmin);
  const isIncomingInvoiceOverview = CompanyService.hasRelation(
    AuthEnums.PersonCompanyRelationType.IncomingInvoicesOverview
  );

  return !(
    (state === ApiModels.IncomingInvoiceState.Signee &&
      (isIncominInvoiceAdmin || isSignee || isIncomingInvoiceOverview)) ||
    state === ApiModels.IncomingInvoiceState.Received ||
    state === ApiModels.IncomingInvoiceState.Unhandled ||
    state === ApiModels.IncomingInvoiceState.SentForProcessing
  );
}

export default useReadOnlyState;
